// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../fonts/IBMPlexSans-Regular.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../fonts/IBMPlexSans-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../fonts/IBMPlexMono-SemiBold.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Lab of Trades — gemeinsames Theme der Remote-SPAs (remote-connect, remote-strategy, remote-open).
 *
 * Farben, Schrift und Button-Sprache folgen der Desktop-App (app/.../style/default.css:
 * -lot-color-*, IBM Plex Sans, btn-primary hellgrün mit dunkler Schrift, btn-ghost mit
 * grünem Rahmen, Radius 6). Technisch werden nur die CSS-Variablen von Bootstrap 5
 * umbelegt — die SPAs benutzen weiter die normalen Bootstrap-Klassen. Alle Regeln tragen das
 * Präfix \`html\`, damit sie unabhängig von der Ladereihenfolge über Bootstrap gewinnen.
 *
 * Bedienbarkeit (Web-Konvention): Alles Anklickbare ist ein echter Button oder eine
 * Aktionszeile mit Pfeil und hat sichtbare Hover-/Druck-/Fokus-Zustände. Reine
 * Statusanzeigen (.lot-status) sehen bewusst NICHT wie Buttons aus.
 */

@font-face {
    font-family: "IBM Plex Sans";
    font-weight: 400;
    font-style: normal;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff");
}

@font-face {
    font-family: "IBM Plex Sans";
    font-weight: 600 700;
    font-style: normal;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

@font-face {
    font-family: "IBM Plex Mono";
    font-weight: 600 700;
    font-style: normal;
    font-display: swap;
    src: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff");
}

html:root,
html[data-bs-theme="dark"] {
    /* Palette der Desktop-App */
    --lot-1: #00120C;
    --lot-2: #002B1C;
    --lot-3: #006944;
    --lot-4: #00AB6E;
    --lot-5: #00FDA3;
    --lot-6: #A1C2B7;
    --lot-7: #D6E4DF;
    --lot-8: #E81A50;
    --lot-surface: #0A1F16;
    --lot-surface-raised: #10291E;
    --lot-outline: #1C3B2C;
    --lot-muted: #8A9A94;
    --lot-warning: #D9A400;
    --lot-radius: 6px;

    /* Bootstrap-Grundfarben */
    --bs-body-bg: var(--lot-1);
    --bs-body-bg-rgb: 0, 18, 12;
    --bs-body-color: var(--lot-7);
    --bs-body-color-rgb: 214, 228, 223;
    --bs-emphasis-color: #FFFFFF;
    --bs-emphasis-color-rgb: 255, 255, 255;
    --bs-secondary-color: var(--lot-6);
    --bs-secondary-color-rgb: 161, 194, 183;
    --bs-secondary-bg: var(--lot-surface-raised);
    --bs-secondary-bg-rgb: 16, 41, 30;
    --bs-tertiary-bg: var(--lot-surface);
    --bs-tertiary-bg-rgb: 10, 31, 22;
    --bs-border-color: var(--lot-outline);
    --bs-border-color-translucent: var(--lot-outline);
    --bs-border-radius: var(--lot-radius);

    /* Themenfarben (für text-*, text-bg-*, border-*) */
    --bs-primary: var(--lot-5);
    --bs-primary-rgb: 0, 253, 163;
    --bs-secondary: var(--lot-6);
    --bs-secondary-rgb: 161, 194, 183;
    --bs-success: var(--lot-4);
    --bs-success-rgb: 0, 171, 110;
    --bs-danger: var(--lot-8);
    --bs-danger-rgb: 232, 26, 80;
    --bs-warning: var(--lot-warning);
    --bs-warning-rgb: 217, 164, 0;
    --bs-info: var(--lot-6);
    --bs-info-rgb: 161, 194, 183;

    --bs-link-color: var(--lot-5);
    --bs-link-color-rgb: 0, 253, 163;
    --bs-link-hover-color: #5CFFC4;
    --bs-link-hover-color-rgb: 92, 255, 196;
    --bs-focus-ring-color: rgba(0, 253, 163, 0.35);

    --bs-font-sans-serif: "IBM Plex Sans", system-ui, -apple-system, "Segoe UI", Roboto, sans-serif;
    --bs-font-monospace: "IBM Plex Mono", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
}

html body {
    font-family: var(--bs-font-sans-serif);
    -webkit-font-smoothing: antialiased;
    /* kein grauer Tap-Blitz auf dem Handy — die eigenen :active-Zustände zeigen den Druck */
    -webkit-tap-highlight-color: transparent;
}

html .fw-bold,
html .fw-semibold,
html h1, h2, h3, h4, h5 {
    font-weight: 600;
}

/* ---- Buttons: die einzige Form für Aktionen ------------------------------------- */

html .btn {
    --bs-btn-border-radius: var(--lot-radius);
    --bs-btn-font-weight: 600;
    --bs-btn-padding-y: 0.55rem; /* mind. 44 px Zielhöhe auf dem Handy */
    --bs-btn-focus-box-shadow: 0 0 0 0.2rem var(--bs-focus-ring-color);
    transition: background-color 0.12s, border-color 0.12s, transform 0.06s;
}

html .btn:active:not(:disabled) {
    transform: scale(0.985);
}

html .btn-sm {
    --bs-btn-padding-y: 0.3rem;
}

/* Hauptaktion — wie .btn-primary am Desktop: hellgrün, dunkle Schrift */
html .btn-primary {
    --bs-btn-color: var(--lot-1);
    --bs-btn-bg: var(--lot-5);
    --bs-btn-border-color: var(--lot-5);
    --bs-btn-hover-color: var(--lot-1);
    --bs-btn-hover-bg: #5CFFC4;
    --bs-btn-hover-border-color: #5CFFC4;
    --bs-btn-active-color: var(--lot-1);
    --bs-btn-active-bg: var(--lot-4);
    --bs-btn-active-border-color: var(--lot-4);
    --bs-btn-disabled-color: var(--lot-1);
    --bs-btn-disabled-bg: var(--lot-5);
    --bs-btn-disabled-border-color: var(--lot-5);
    --bs-btn-disabled-opacity: 0.4;
}

/* Nebenaktion — wie .btn-ghost am Desktop: transparenter Grund, grüner Rahmen */
html .btn-secondary,
html .btn-outline-secondary,
html .btn-outline-primary {
    --bs-btn-color: var(--lot-7);
    --bs-btn-bg: transparent;
    --bs-btn-border-color: var(--lot-4);
    --bs-btn-hover-color: #FFFFFF;
    --bs-btn-hover-bg: var(--lot-2);
    --bs-btn-hover-border-color: var(--lot-5);
    --bs-btn-active-color: #FFFFFF;
    --bs-btn-active-bg: var(--lot-3);
    --bs-btn-active-border-color: var(--lot-5);
    --bs-btn-disabled-color: var(--lot-muted);
    --bs-btn-disabled-bg: transparent;
    --bs-btn-disabled-border-color: var(--lot-outline);
}

/* gewählter Zustand in Umschaltern (Sprache, Button-Gruppen) */
html .btn-outline-secondary.active,
html .btn-check:checked + .btn-outline-secondary,
html .btn-check:checked + .btn-outline-primary {
    --bs-btn-active-color: var(--lot-1);
    --bs-btn-active-bg: var(--lot-5);
    --bs-btn-active-border-color: var(--lot-5);
}

html .btn-danger {
    --bs-btn-color: #FFFFFF;
    --bs-btn-bg: var(--lot-8);
    --bs-btn-border-color: var(--lot-8);
    --bs-btn-hover-bg: #F23A68;
    --bs-btn-hover-border-color: #F23A68;
    --bs-btn-active-bg: #C4123F;
    --bs-btn-active-border-color: #C4123F;
}

html .btn-outline-danger {
    --bs-btn-color: #FF6B8E;
    --bs-btn-border-color: var(--lot-8);
    --bs-btn-hover-color: #FFFFFF;
    --bs-btn-hover-bg: var(--lot-8);
    --bs-btn-hover-border-color: var(--lot-8);
    --bs-btn-active-color: #FFFFFF;
    --bs-btn-active-bg: #C4123F;
    --bs-btn-active-border-color: #C4123F;
}

/* Textlinks: Akzentfarbe + Unterstreichung, damit sie als Link erkennbar bleiben */
html a,
html .btn-link {
    color: var(--lot-5);
    text-decoration: underline;
    text-underline-offset: 0.18em;
}

html :focus-visible {
    outline: 2px solid var(--lot-5);
    outline-offset: 2px;
}

/* ---- Flächen ----------------------------------------------------------------------- */

html .card {
    --bs-card-bg: var(--lot-surface);
    --bs-card-border-color: var(--lot-outline);
    --bs-card-border-radius: 10px;
    --bs-card-inner-border-radius: 9px;
}

html .card-footer {
    background-color: transparent;
    border-top: 1px solid var(--lot-outline);
}

html .list-group {
    --bs-list-group-bg: var(--lot-surface);
    --bs-list-group-color: var(--lot-7);
    --bs-list-group-border-color: var(--lot-outline);
    --bs-list-group-border-radius: 10px;
    --bs-list-group-action-color: var(--lot-7);
    --bs-list-group-action-hover-color: #FFFFFF;
    --bs-list-group-action-hover-bg: var(--lot-surface-raised);
    --bs-list-group-action-active-color: #FFFFFF;
    --bs-list-group-action-active-bg: var(--lot-2);
}

html .form-control,
html .form-select {
    background-color: var(--lot-surface-raised);
    border-color: var(--lot-outline);
    color: var(--lot-7);
    border-radius: var(--lot-radius);
}

html .form-control:focus,
html .form-select:focus {
    background-color: var(--lot-surface-raised);
    border-color: var(--lot-4);
    color: #FFFFFF;
    box-shadow: 0 0 0 0.2rem var(--bs-focus-ring-color);
}

html .form-control::placeholder {
    color: var(--lot-muted);
}

html .form-check-input {
    background-color: var(--lot-surface-raised);
    border-color: var(--lot-4);
}

html .form-check-input:checked {
    background-color: var(--lot-4);
    border-color: var(--lot-4);
}

html .alert {
    --bs-alert-border-radius: var(--lot-radius);
}

html .alert-info {
    --bs-alert-color: var(--lot-7);
    --bs-alert-bg: var(--lot-surface-raised);
    --bs-alert-border-color: var(--lot-3);
}

html .alert-warning {
    --bs-alert-color: #FFE08A;
    --bs-alert-bg: #2A2300;
    --bs-alert-border-color: #6B5200;
}

html .alert-danger {
    --bs-alert-color: #FFB3C4;
    --bs-alert-bg: #2E0812;
    --bs-alert-border-color: #7A1230;
}

html .text-bg-success {
    color: var(--lot-1) !important;
}

html .spinner-border.text-primary {
    color: var(--lot-4) !important;
}

/* ---- Aktionszeile: anklickbare Zeile/Karte, die irgendwohin führt ------------------ */

html .lot-action {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    width: 100%;
    text-align: left;
    color: var(--lot-7);
    background-color: var(--lot-surface);
    border: 1px solid var(--lot-outline);
    border-radius: 10px;
    padding: 0.85rem 1rem;
    cursor: pointer;
    transition: background-color 0.12s, border-color 0.12s;
}

html .lot-action:hover {
    background-color: var(--lot-surface-raised);
    border-color: var(--lot-4);
}

html .lot-action:active {
    background-color: var(--lot-2);
}

/* der Pfeil rechts sagt: hier geht es weiter */
html .lot-action .lot-chevron {
    color: var(--lot-4);
    flex: none;
}

html .lot-action:hover .lot-chevron {
    color: var(--lot-5);
}

/* ---- Statusanzeige: Punkt + Text, bewusst kein Button-Look -------------------------- */

html .lot-status {
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
    font-size: 0.875rem;
    font-weight: 600;
    white-space: nowrap;
}

html .lot-status::before {
    content: "";
    width: 0.6rem;
    height: 0.6rem;
    border-radius: 50%;
    background-color: currentColor;
    flex: none;
}

.lot-status-ok { color: var(--lot-5); }
.lot-status-bad { color: #FF6B8E; }
.lot-status-warn { color: var(--lot-warning); }
.lot-status-idle { color: var(--lot-muted); }

/* ---- Einzelteile ----------------------------------------------------------------------- */

html .lot-brand {
    letter-spacing: 0.01em;
}

/* Sicherheitscode wie im Desktop-Dialog: Mono, Akzentgrün */
html .lot-sas {
    font-family: var(--bs-font-monospace);
    color: var(--lot-4);
    letter-spacing: 0.08em;
}

html .qr-scanner {
    border: 1px solid var(--lot-outline);
}

/* Bestätigungs-/Offline-Overlays über dem dunklen Grund */
html .bg-dark {
    --bs-dark-rgb: 0, 18, 12;
}
`, "",{"version":3,"sources":["webpack://./kotlin/css/lot-theme.css"],"names":[],"mappings":"AAAA;;;;;;;;;;;;EAYE;;AAEF;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,kBAAkB;IAClB,kBAAkB;IAClB,2DAA4D;AAChE;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,2DAA6D;AACjE;;AAEA;IACI,4BAA4B;IAC5B,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,2DAA6D;AACjE;;AAEA;;IAEI,4BAA4B;IAC5B,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,sBAAsB;IACtB,6BAA6B;IAC7B,sBAAsB;IACtB,oBAAoB;IACpB,sBAAsB;IACtB,iBAAiB;;IAEjB,0BAA0B;IAC1B,0BAA0B;IAC1B,2BAA2B;IAC3B,6BAA6B;IAC7B,kCAAkC;IAClC,4BAA4B;IAC5B,sCAAsC;IACtC,kCAAkC;IAClC,uCAAuC;IACvC,4CAA4C;IAC5C,iCAAiC;IACjC,oCAAoC;IACpC,gCAAgC;IAChC,qCAAqC;IACrC,iDAAiD;IACjD,qCAAqC;;IAErC,mDAAmD;IACnD,0BAA0B;IAC1B,6BAA6B;IAC7B,4BAA4B;IAC5B,iCAAiC;IACjC,0BAA0B;IAC1B,6BAA6B;IAC7B,yBAAyB;IACzB,4BAA4B;IAC5B,gCAAgC;IAChC,6BAA6B;IAC7B,uBAAuB;IACvB,4BAA4B;;IAE5B,6BAA6B;IAC7B,gCAAgC;IAChC,8BAA8B;IAC9B,uCAAuC;IACvC,8CAA8C;;IAE9C,+FAA+F;IAC/F,8FAA8F;AAClG;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,wFAAwF;IACxF,wCAAwC;AAC5C;;AAEA;;;IAGI,gBAAgB;AACpB;;AAEA,sFAAsF;;AAEtF;IACI,yCAAyC;IACzC,yBAAyB;IACzB,2BAA2B,EAAE,uCAAuC;IACpE,kEAAkE;IAClE,uEAAuE;AAC3E;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,wEAAwE;AACxE;IACI,4BAA4B;IAC5B,yBAAyB;IACzB,mCAAmC;IACnC,kCAAkC;IAClC,0BAA0B;IAC1B,oCAAoC;IACpC,mCAAmC;IACnC,gCAAgC;IAChC,0CAA0C;IAC1C,qCAAqC;IACrC,kCAAkC;IAClC,4CAA4C;IAC5C,8BAA8B;AAClC;;AAEA,gFAAgF;AAChF;;;IAGI,4BAA4B;IAC5B,wBAAwB;IACxB,mCAAmC;IACnC,6BAA6B;IAC7B,+BAA+B;IAC/B,yCAAyC;IACzC,8BAA8B;IAC9B,gCAAgC;IAChC,0CAA0C;IAC1C,yCAAyC;IACzC,iCAAiC;IACjC,kDAAkD;AACtD;;AAEA,+DAA+D;AAC/D;;;IAGI,mCAAmC;IACnC,gCAAgC;IAChC,0CAA0C;AAC9C;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mCAAmC;IACnC,0BAA0B;IAC1B,oCAAoC;IACpC,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA;IACI,uBAAuB;IACvB,mCAAmC;IACnC,6BAA6B;IAC7B,+BAA+B;IAC/B,yCAAyC;IACzC,8BAA8B;IAC9B,2BAA2B;IAC3B,qCAAqC;AACzC;;AAEA,mFAAmF;AACnF;;IAEI,mBAAmB;IACnB,0BAA0B;IAC1B,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,mBAAmB;AACvB;;AAEA,yFAAyF;;AAEzF;IACI,gCAAgC;IAChC,0CAA0C;IAC1C,6BAA6B;IAC7B,kCAAkC;AACtC;;AAEA;IACI,6BAA6B;IAC7B,wCAAwC;AAC5C;;AAEA;IACI,sCAAsC;IACtC,mCAAmC;IACnC,gDAAgD;IAChD,mCAAmC;IACnC,0CAA0C;IAC1C,2CAA2C;IAC3C,0DAA0D;IAC1D,4CAA4C;IAC5C,8CAA8C;AAClD;;AAEA;;IAEI,2CAA2C;IAC3C,gCAAgC;IAChC,mBAAmB;IACnB,gCAAgC;AACpC;;AAEA;;IAEI,2CAA2C;IAC3C,0BAA0B;IAC1B,cAAc;IACd,mDAAmD;AACvD;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,2CAA2C;IAC3C,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;IAC9B,0BAA0B;AAC9B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,8BAA8B;IAC9B,wCAAwC;IACxC,qCAAqC;AACzC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,yBAAyB;IACzB,sBAAsB;IACtB,gCAAgC;AACpC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA,yFAAyF;;AAEzF;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,WAAW;IACX,gBAAgB;IAChB,mBAAmB;IACnB,oCAAoC;IACpC,oCAAoC;IACpC,mBAAmB;IACnB,qBAAqB;IACrB,eAAe;IACf,sDAAsD;AAC1D;;AAEA;IACI,2CAA2C;IAC3C,0BAA0B;AAC9B;;AAEA;IACI,8BAA8B;AAClC;;AAEA,+CAA+C;AAC/C;IACI,mBAAmB;IACnB,UAAU;AACd;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0FAA0F;;AAE1F;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,UAAU;AACd;;AAEA,iBAAiB,mBAAmB,EAAE;AACtC,kBAAkB,cAAc,EAAE;AAClC,mBAAmB,yBAAyB,EAAE;AAC9C,mBAAmB,uBAAuB,EAAE;;AAE5C,6FAA6F;;AAE7F;IACI,sBAAsB;AAC1B;;AAEA,4DAA4D;AAC5D;IACI,qCAAqC;IACrC,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,oCAAoC;AACxC;;AAEA,0DAA0D;AAC1D;IACI,wBAAwB;AAC5B","sourcesContent":["/*\n * Lab of Trades — gemeinsames Theme der Remote-SPAs (remote-connect, remote-strategy, remote-open).\n *\n * Farben, Schrift und Button-Sprache folgen der Desktop-App (app/.../style/default.css:\n * -lot-color-*, IBM Plex Sans, btn-primary hellgrün mit dunkler Schrift, btn-ghost mit\n * grünem Rahmen, Radius 6). Technisch werden nur die CSS-Variablen von Bootstrap 5\n * umbelegt — die SPAs benutzen weiter die normalen Bootstrap-Klassen. Alle Regeln tragen das\n * Präfix `html`, damit sie unabhängig von der Ladereihenfolge über Bootstrap gewinnen.\n *\n * Bedienbarkeit (Web-Konvention): Alles Anklickbare ist ein echter Button oder eine\n * Aktionszeile mit Pfeil und hat sichtbare Hover-/Druck-/Fokus-Zustände. Reine\n * Statusanzeigen (.lot-status) sehen bewusst NICHT wie Buttons aus.\n */\n\n@font-face {\n    font-family: \"IBM Plex Sans\";\n    font-weight: 400;\n    font-style: normal;\n    font-display: swap;\n    src: url(\"../fonts/IBMPlexSans-Regular.woff\") format(\"woff\");\n}\n\n@font-face {\n    font-family: \"IBM Plex Sans\";\n    font-weight: 600 700;\n    font-style: normal;\n    font-display: swap;\n    src: url(\"../fonts/IBMPlexSans-SemiBold.woff\") format(\"woff\");\n}\n\n@font-face {\n    font-family: \"IBM Plex Mono\";\n    font-weight: 600 700;\n    font-style: normal;\n    font-display: swap;\n    src: url(\"../fonts/IBMPlexMono-SemiBold.woff\") format(\"woff\");\n}\n\nhtml:root,\nhtml[data-bs-theme=\"dark\"] {\n    /* Palette der Desktop-App */\n    --lot-1: #00120C;\n    --lot-2: #002B1C;\n    --lot-3: #006944;\n    --lot-4: #00AB6E;\n    --lot-5: #00FDA3;\n    --lot-6: #A1C2B7;\n    --lot-7: #D6E4DF;\n    --lot-8: #E81A50;\n    --lot-surface: #0A1F16;\n    --lot-surface-raised: #10291E;\n    --lot-outline: #1C3B2C;\n    --lot-muted: #8A9A94;\n    --lot-warning: #D9A400;\n    --lot-radius: 6px;\n\n    /* Bootstrap-Grundfarben */\n    --bs-body-bg: var(--lot-1);\n    --bs-body-bg-rgb: 0, 18, 12;\n    --bs-body-color: var(--lot-7);\n    --bs-body-color-rgb: 214, 228, 223;\n    --bs-emphasis-color: #FFFFFF;\n    --bs-emphasis-color-rgb: 255, 255, 255;\n    --bs-secondary-color: var(--lot-6);\n    --bs-secondary-color-rgb: 161, 194, 183;\n    --bs-secondary-bg: var(--lot-surface-raised);\n    --bs-secondary-bg-rgb: 16, 41, 30;\n    --bs-tertiary-bg: var(--lot-surface);\n    --bs-tertiary-bg-rgb: 10, 31, 22;\n    --bs-border-color: var(--lot-outline);\n    --bs-border-color-translucent: var(--lot-outline);\n    --bs-border-radius: var(--lot-radius);\n\n    /* Themenfarben (für text-*, text-bg-*, border-*) */\n    --bs-primary: var(--lot-5);\n    --bs-primary-rgb: 0, 253, 163;\n    --bs-secondary: var(--lot-6);\n    --bs-secondary-rgb: 161, 194, 183;\n    --bs-success: var(--lot-4);\n    --bs-success-rgb: 0, 171, 110;\n    --bs-danger: var(--lot-8);\n    --bs-danger-rgb: 232, 26, 80;\n    --bs-warning: var(--lot-warning);\n    --bs-warning-rgb: 217, 164, 0;\n    --bs-info: var(--lot-6);\n    --bs-info-rgb: 161, 194, 183;\n\n    --bs-link-color: var(--lot-5);\n    --bs-link-color-rgb: 0, 253, 163;\n    --bs-link-hover-color: #5CFFC4;\n    --bs-link-hover-color-rgb: 92, 255, 196;\n    --bs-focus-ring-color: rgba(0, 253, 163, 0.35);\n\n    --bs-font-sans-serif: \"IBM Plex Sans\", system-ui, -apple-system, \"Segoe UI\", Roboto, sans-serif;\n    --bs-font-monospace: \"IBM Plex Mono\", ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;\n}\n\nhtml body {\n    font-family: var(--bs-font-sans-serif);\n    -webkit-font-smoothing: antialiased;\n    /* kein grauer Tap-Blitz auf dem Handy — die eigenen :active-Zustände zeigen den Druck */\n    -webkit-tap-highlight-color: transparent;\n}\n\nhtml .fw-bold,\nhtml .fw-semibold,\nhtml h1, h2, h3, h4, h5 {\n    font-weight: 600;\n}\n\n/* ---- Buttons: die einzige Form für Aktionen ------------------------------------- */\n\nhtml .btn {\n    --bs-btn-border-radius: var(--lot-radius);\n    --bs-btn-font-weight: 600;\n    --bs-btn-padding-y: 0.55rem; /* mind. 44 px Zielhöhe auf dem Handy */\n    --bs-btn-focus-box-shadow: 0 0 0 0.2rem var(--bs-focus-ring-color);\n    transition: background-color 0.12s, border-color 0.12s, transform 0.06s;\n}\n\nhtml .btn:active:not(:disabled) {\n    transform: scale(0.985);\n}\n\nhtml .btn-sm {\n    --bs-btn-padding-y: 0.3rem;\n}\n\n/* Hauptaktion — wie .btn-primary am Desktop: hellgrün, dunkle Schrift */\nhtml .btn-primary {\n    --bs-btn-color: var(--lot-1);\n    --bs-btn-bg: var(--lot-5);\n    --bs-btn-border-color: var(--lot-5);\n    --bs-btn-hover-color: var(--lot-1);\n    --bs-btn-hover-bg: #5CFFC4;\n    --bs-btn-hover-border-color: #5CFFC4;\n    --bs-btn-active-color: var(--lot-1);\n    --bs-btn-active-bg: var(--lot-4);\n    --bs-btn-active-border-color: var(--lot-4);\n    --bs-btn-disabled-color: var(--lot-1);\n    --bs-btn-disabled-bg: var(--lot-5);\n    --bs-btn-disabled-border-color: var(--lot-5);\n    --bs-btn-disabled-opacity: 0.4;\n}\n\n/* Nebenaktion — wie .btn-ghost am Desktop: transparenter Grund, grüner Rahmen */\nhtml .btn-secondary,\nhtml .btn-outline-secondary,\nhtml .btn-outline-primary {\n    --bs-btn-color: var(--lot-7);\n    --bs-btn-bg: transparent;\n    --bs-btn-border-color: var(--lot-4);\n    --bs-btn-hover-color: #FFFFFF;\n    --bs-btn-hover-bg: var(--lot-2);\n    --bs-btn-hover-border-color: var(--lot-5);\n    --bs-btn-active-color: #FFFFFF;\n    --bs-btn-active-bg: var(--lot-3);\n    --bs-btn-active-border-color: var(--lot-5);\n    --bs-btn-disabled-color: var(--lot-muted);\n    --bs-btn-disabled-bg: transparent;\n    --bs-btn-disabled-border-color: var(--lot-outline);\n}\n\n/* gewählter Zustand in Umschaltern (Sprache, Button-Gruppen) */\nhtml .btn-outline-secondary.active,\nhtml .btn-check:checked + .btn-outline-secondary,\nhtml .btn-check:checked + .btn-outline-primary {\n    --bs-btn-active-color: var(--lot-1);\n    --bs-btn-active-bg: var(--lot-5);\n    --bs-btn-active-border-color: var(--lot-5);\n}\n\nhtml .btn-danger {\n    --bs-btn-color: #FFFFFF;\n    --bs-btn-bg: var(--lot-8);\n    --bs-btn-border-color: var(--lot-8);\n    --bs-btn-hover-bg: #F23A68;\n    --bs-btn-hover-border-color: #F23A68;\n    --bs-btn-active-bg: #C4123F;\n    --bs-btn-active-border-color: #C4123F;\n}\n\nhtml .btn-outline-danger {\n    --bs-btn-color: #FF6B8E;\n    --bs-btn-border-color: var(--lot-8);\n    --bs-btn-hover-color: #FFFFFF;\n    --bs-btn-hover-bg: var(--lot-8);\n    --bs-btn-hover-border-color: var(--lot-8);\n    --bs-btn-active-color: #FFFFFF;\n    --bs-btn-active-bg: #C4123F;\n    --bs-btn-active-border-color: #C4123F;\n}\n\n/* Textlinks: Akzentfarbe + Unterstreichung, damit sie als Link erkennbar bleiben */\nhtml a,\nhtml .btn-link {\n    color: var(--lot-5);\n    text-decoration: underline;\n    text-underline-offset: 0.18em;\n}\n\nhtml :focus-visible {\n    outline: 2px solid var(--lot-5);\n    outline-offset: 2px;\n}\n\n/* ---- Flächen ----------------------------------------------------------------------- */\n\nhtml .card {\n    --bs-card-bg: var(--lot-surface);\n    --bs-card-border-color: var(--lot-outline);\n    --bs-card-border-radius: 10px;\n    --bs-card-inner-border-radius: 9px;\n}\n\nhtml .card-footer {\n    background-color: transparent;\n    border-top: 1px solid var(--lot-outline);\n}\n\nhtml .list-group {\n    --bs-list-group-bg: var(--lot-surface);\n    --bs-list-group-color: var(--lot-7);\n    --bs-list-group-border-color: var(--lot-outline);\n    --bs-list-group-border-radius: 10px;\n    --bs-list-group-action-color: var(--lot-7);\n    --bs-list-group-action-hover-color: #FFFFFF;\n    --bs-list-group-action-hover-bg: var(--lot-surface-raised);\n    --bs-list-group-action-active-color: #FFFFFF;\n    --bs-list-group-action-active-bg: var(--lot-2);\n}\n\nhtml .form-control,\nhtml .form-select {\n    background-color: var(--lot-surface-raised);\n    border-color: var(--lot-outline);\n    color: var(--lot-7);\n    border-radius: var(--lot-radius);\n}\n\nhtml .form-control:focus,\nhtml .form-select:focus {\n    background-color: var(--lot-surface-raised);\n    border-color: var(--lot-4);\n    color: #FFFFFF;\n    box-shadow: 0 0 0 0.2rem var(--bs-focus-ring-color);\n}\n\nhtml .form-control::placeholder {\n    color: var(--lot-muted);\n}\n\nhtml .form-check-input {\n    background-color: var(--lot-surface-raised);\n    border-color: var(--lot-4);\n}\n\nhtml .form-check-input:checked {\n    background-color: var(--lot-4);\n    border-color: var(--lot-4);\n}\n\nhtml .alert {\n    --bs-alert-border-radius: var(--lot-radius);\n}\n\nhtml .alert-info {\n    --bs-alert-color: var(--lot-7);\n    --bs-alert-bg: var(--lot-surface-raised);\n    --bs-alert-border-color: var(--lot-3);\n}\n\nhtml .alert-warning {\n    --bs-alert-color: #FFE08A;\n    --bs-alert-bg: #2A2300;\n    --bs-alert-border-color: #6B5200;\n}\n\nhtml .alert-danger {\n    --bs-alert-color: #FFB3C4;\n    --bs-alert-bg: #2E0812;\n    --bs-alert-border-color: #7A1230;\n}\n\nhtml .text-bg-success {\n    color: var(--lot-1) !important;\n}\n\nhtml .spinner-border.text-primary {\n    color: var(--lot-4) !important;\n}\n\n/* ---- Aktionszeile: anklickbare Zeile/Karte, die irgendwohin führt ------------------ */\n\nhtml .lot-action {\n    display: flex;\n    align-items: center;\n    gap: 0.75rem;\n    width: 100%;\n    text-align: left;\n    color: var(--lot-7);\n    background-color: var(--lot-surface);\n    border: 1px solid var(--lot-outline);\n    border-radius: 10px;\n    padding: 0.85rem 1rem;\n    cursor: pointer;\n    transition: background-color 0.12s, border-color 0.12s;\n}\n\nhtml .lot-action:hover {\n    background-color: var(--lot-surface-raised);\n    border-color: var(--lot-4);\n}\n\nhtml .lot-action:active {\n    background-color: var(--lot-2);\n}\n\n/* der Pfeil rechts sagt: hier geht es weiter */\nhtml .lot-action .lot-chevron {\n    color: var(--lot-4);\n    flex: none;\n}\n\nhtml .lot-action:hover .lot-chevron {\n    color: var(--lot-5);\n}\n\n/* ---- Statusanzeige: Punkt + Text, bewusst kein Button-Look -------------------------- */\n\nhtml .lot-status {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.4rem;\n    font-size: 0.875rem;\n    font-weight: 600;\n    white-space: nowrap;\n}\n\nhtml .lot-status::before {\n    content: \"\";\n    width: 0.6rem;\n    height: 0.6rem;\n    border-radius: 50%;\n    background-color: currentColor;\n    flex: none;\n}\n\n.lot-status-ok { color: var(--lot-5); }\n.lot-status-bad { color: #FF6B8E; }\n.lot-status-warn { color: var(--lot-warning); }\n.lot-status-idle { color: var(--lot-muted); }\n\n/* ---- Einzelteile ----------------------------------------------------------------------- */\n\nhtml .lot-brand {\n    letter-spacing: 0.01em;\n}\n\n/* Sicherheitscode wie im Desktop-Dialog: Mono, Akzentgrün */\nhtml .lot-sas {\n    font-family: var(--bs-font-monospace);\n    color: var(--lot-4);\n    letter-spacing: 0.08em;\n}\n\nhtml .qr-scanner {\n    border: 1px solid var(--lot-outline);\n}\n\n/* Bestätigungs-/Offline-Overlays über dem dunklen Grund */\nhtml .bg-dark {\n    --bs-dark-rgb: 0, 18, 12;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
